import React from "react";
import { useFetch, NeedTenant } from "../hooks/useData";
import { GlassCard, Loading, SectionTitle } from "../components/common";
import { ScrollText, ShieldCheck } from "lucide-react";

function Inner() {
  const { data, loading } = useFetch("/audit-logs");
  if (loading) return <Loading />;
  const logs = data || [];
  return (
    <div className="space-y-5 pm-fade-up">
      <SectionTitle eyebrow="Security" title="Audit Log" sub="Immutable, tamper-evident record of all workspace activity" />
      <GlassCard className="p-2 overflow-x-auto">
        <div className="flex items-center gap-2 px-4 pt-3 pb-2 text-emerald-600 text-xs font-semibold"><ShieldCheck className="w-4 h-4" />Tamper-evident · {logs.length} entries</div>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-400"><th className="p-3">Actor</th><th className="p-3">Action</th><th className="p-3">Resource</th><th className="p-3">Timestamp</th></tr></thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-white/50 hover:bg-white/40" data-testid={`audit-${l.id}`}>
                <td className="p-3 font-medium text-slate-700">{l.user_name}</td>
                <td className="p-3"><span className="font-mono text-xs bg-slate-100 text-slate-700 px-2 py-0.5 rounded">{l.action}</span></td>
                <td className="p-3 text-slate-600">{l.resource}{l.details && <span className="text-slate-400 text-xs ml-1">· {l.details}</span>}</td>
                <td className="p-3 text-slate-400 text-xs font-mono">{new Date(l.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!logs.length && <div className="p-10 text-center text-slate-400 text-sm">No audit entries yet.</div>}
      </GlassCard>
    </div>
  );
}

export default function AuditLog() { return <NeedTenant><Inner /></NeedTenant>; }
